import { Media, MediaConfig, MediaFormatSize } from '@spartacus/storefront'

export declare type EbPicture = EbPictureSource[]

export declare type EbPictureSource = {
  minWidth?: number
  maxWidth?: number
  query?: string[]
  media: Media
}

export declare type MediaFormat = {
  code: string
  size: MediaFormatSize
}

export const leftMediaConfig: MediaConfig = {
  mediaFormats: {
    left: { width: 400 },
    tablet: { width: 770 },
    desktop: { width: 1140 },
    widescreen: { width: 1400 }
  }
}

export const rightMediaConfig: MediaConfig = {
  mediaFormats: {
    right: { width: 400 },
    tablet: { width: 770 },
    desktop: { width: 1140 },
    widescreen: { width: 1400 }
  }
}
